export class OperacionI{
  id:number;
  descripcion:String;
  nombre:String;
}
